import React from 'react';
import { PageWrapper } from '../components/pagewrapper/PageWrapper';

export const Terms = () => {
  return (
    <PageWrapper>
      <h2>LOÓNA TERMS OF USE</h2>
      <p>
        <i>Effective Date: February 23, 2024.</i>
      </p>
      <h2>
        <span>Introduction and Acceptance</span>
      </h2>
      <p>
        <span>
          Please read these Terms (as hereinafter defined) carefully. By using
          the Loóna mobile application (the <b>“App”</b>) or the website located
          at https://loona.app/ (the <b>“Website”</b>) (App and Website
          individually referred to individually as a <b>“Loóna Service”</b> or
          collectively as the <b>“Loóna Services”</b>) or otherwise indicating
          your acceptance (e.g. by clicking tick-box or bottom “agree”), you
          agree to the following terms, which will bind you at all times and in
          whatever manner you use the Loóna Services. In these Terms, anyone who
          uses the Loóna Services is considered a <b>“User”</b>. If you do not
          agree, or you do not have the authority to accept these Terms, you
          must not use the Loóna Services.
        </span>
      </p>
      <p>
        <span>
          Loona Inc. and any of our affiliated entities (referred here to as
          <b> “Loona”, “we”, “us” and “our”</b>) permit you to use the Loóna
          Services as described in these Terms.{' '}
        </span>
      </p>
      <p>
        <span>
          You should note the following rules which apply to these terms and
          conditions:
        </span>
        <ul>
          <li>
            the headings do not affect the interpretation of any provisions;
          </li>
          <li>
            where we use the singular of a word, this also includes the plural
            (or vice versa); and
          </li>
          <li>
            if we use terms such as “including”, “include”, “in particular”,
            “for example” or any similar expression, we do this for illustrative
            purposes only and this does not limit the scope or meaning of the
            overall provision (i.e. where we use such words, we are providing
            examples only and the examples are not exhaustive).
          </li>
        </ul>
      </p>
      <p>
        <span>
          <b>NOTICE REGARDING DISPUTE RESOLUTION FOR THE U.S. USERS:</b> THIS
          NOTICE IS APPLICABLE TO <u>U.S. USERS ONLY</u> (A) A U.S. CITIZEN; (B)
          A PERSON THAT RESIDES IN THE U.S.; (C) A PERSON THAT IS ACCESSING THE
          LOÓNA SERVICES FROM THE U.S.{' '}
          <b>
            <u>(U.S. USER)</u>
          </b>
          , THESE TERMS CONTAIN PROVISIONS THAT GOVERN HOW CLAIMS YOU AND WE
          HAVE AGAINST EACH OTHER ARE RESOLVED, INCLUDING AN OBLIGATION TO
          ARBITRATE DISPUTES, WHICH WILL, SUBJECT TO LIMITED EXCEPTIONS, REQUIRE
          YOU TO SUBMIT CLAIMS YOU HAVE AGAINST US TO BINDING ARBITRATION,
          UNLESS YOU OPT-OUT. UNLESS YOU OPT-OUT OF ARBITRATION: (A) YOU WILL
          ONLY BE PERMITTED TO PURSUE CLAIMS AGAINST US ON AN INDIVIDUAL BASIS,
          NOT AS PART OF ANY CLASS OR REPRESENTATIVE ACTION OR PROCEEDING AND
          (B) YOU WILL ONLY BE PERMITTED TO SEEK RELIEF (INCLUDING MONETARY,
          INJUNCTIVE, AND DECLARATORY RELIEF) ON AN INDIVIDUAL BASIS.{' '}
        </span>
      </p>
      <ol>
        <li>
          <b>Application of Terms </b>
        </li>
        <p>
          <span>
            These Terms, together with any other documents which we tell you are
            part of them (collectively these <b>“Terms”</b>), set out the terms
            on which Loóna Services are provided to Users.
          </span>
        </p>
        <p>
          <span>
            Our Privacy Policy should also be read alongside these Terms. Under
            data protection legislation, we are required to provide you with
            certain information including who we are, how we process your
            personal data, and for what purposes and your rights in relation to
            your personal data and how to exercise them. This information is
            provided in our Privacy Policy which you can find here:
            https://loona.app/privacy.
          </span>
        </p>

        <li>
          <b>Changes to these Terms</b>
        </li>
        <p>
          <span>
            We may make changes to these Terms at any time, including, for
            example only, in order to: (a) comply with any changes to the law or
            regulations that apply; (b) to reflect any technical changes, such
            as to respond to security breaches; or (c) deal with changes to
            Users’ needs and changes to our business. You should check these
            Terms each time you access the Loóna Services to ensure you
            understand the terms that apply at that time.
          </span>
        </p>
        <p>
          <span>
            Provided you have registered an account with us, we will try to
            notify you of any changes to these Terms (e.g., by email or a pop-up
            notice when you next access your account).
          </span>
        </p>
        <p>
          <span>
            In addition, we reserve the right to provide you with operating
            rules or additional terms that may govern your use of Loóna Services
            generally, unique of Loóna Services, or both{' '}
            <b>(“Additional Terms”)</b>. Any Additional Terms that we may
            provide to you will be incorporated by reference into these Terms of
            Use. To the extent any Additional Terms conflict with these Terms of
            Use, the Additional Terms will control.
          </span>
        </p>
        <p>
          <span>
            If you do not agree to any changes to these Terms that we may make,
            do not use the Loóna Services. In addition, you may close your
            account by contacting us hello@loona.app.
          </span>
        </p>
        <p>
          <span>
            We may update and change our Website and our App from time to time,
            to reflect changes to needs of our Users and business. We will try
            to give you notice of any major changes.
          </span>
        </p>
        <li>
          <b> Creating an Account</b>
        </li>
        <p>
          <span>
            Certain features or functionalities, that we may establish and
            maintain from time to time and in our sole discretion, may require
            you to register an account with us (“Account”). You can create an
            account in the Loóna Services by following the on-screen
            instructions. As part of this process, you will need to provide
            certain information about you in order to create your account.
            Please see our Privacy Policy for how we use this information.
          </span>
        </p>
        <p>
          {' '}
          <span>
            All information provided by you when creating an account must be
            accurate and complete. If your account information changes at any
            time, you must update it as soon as possible.
          </span>
        </p>
        <p>
          <span>
            You are responsible for all activity that occurs via your account
            even if that activity is not by you or is without your knowledge or
            consent.
          </span>
        </p>
        <p>
          <span>
            You must treat all account information as confidential, and you must
            not share it with anyone else. Only you can use your account and you
            are responsible for keeping your password secret. If you know or
            suspect that anyone other than you knows your password, you must
            promptly notify us, please email us at hello@loona.app.
          </span>
        </p>
        <p>
          <span>
            We have the right to disable any User identification code or
            password (which includes access to your account), whether chosen by
            you or allocated by us, at any time, in our sole discretion and with
            immediate effect, including (but not limited to) if in our
            reasonable opinion you have failed to comply with any of these
            Terms. We will notify you in the Loóna Services if this occurs.
          </span>
        </p>
        <p>
          <span>
            You may register your Account using a valid account on the app store
            or marketplace from which you downloaded Loóna (e.g. Apple App
            Store, Google Play, etc.) (each such account, a “Third-Party
            Account”). By using a Third-Party Account to register your account,
            you are allowing Loóna to access your Third-Party Account as
            permitted under the applicable terms and conditions that govern your
            and/our use of such Third-Party Account.
          </span>
        </p>
        <p>
          <span>
            Please note that your relationship with the third-party service
            providers associated with your third-party accounts is governed
            solely by your agreement(s) with such third-party service providers.
          </span>
        </p>
        <li>
          <b> Accessing Loóna Services</b>
        </li>
        <p>
          <span>
            <strong>General age limitation.</strong> You are not permitted to
            access or use the Loóna Services unless you are at least{' '}
            <strong>13 years old</strong>. By using our Loóna Service, you
            confirm that you are at least
            <strong> 13 years old</strong>. Minors may only use the service with
            the involvement, supervision, and approval of a parent or legal
            guardian. If you are a parent or guardian and believe we have
            collected information from your child who is under the age of 13,
            please contact us at privacy@loona.app.
          </span>
        </p>
        <p>
          <span>
            Any registration by, use of or access to the Game by anyone under
            13, or by anyone who is under 18 acting without parental or guardian
            consent, is unauthorized, unlicensed and in violation of these
            Terms.
          </span>
        </p>
        <p>
          <span>
            IF YOU ARE AT LEAST 13 YEARS OLD BUT UNDER 18 YEARS OF AGE, YOU
            AGREE THAT YOUR PARENT OR LEGAL GUARDIAN HAS REVIEWED AND AGREED TO
            THESE TERMS, AND YOU CAN FORM A BINDING CONTRACT WITH LOÓNA.
          </span>
        </p>
        <p>
          <span>
            <strong>Age limitation for EEA/UK individuals.</strong> Age
            limitation for EEA/UK individuals. You must be at least 16 years old
            in order to use Loóna Services. We do not allow use of Loóna by EEA
            individuals younger than 16 years old. If you are aware of anyone
            younger than 16 using Loóna, please contact us by e-mail:
            privacy@loona.app, and we will take the required steps to delete the
            information provided by such persons.
          </span>
        </p>
        <li>
          <b>Loóna Content</b>
        </li>
        <p>
          <span>
            Loóna Services and associated content (and any derivative works or
            enhancements of the same) including, but not limited to, all
            artwork, text, illustrations, files, images, software, scripts,
            graphics, photos, logos, slogans, audio, sounds, music, videos,
            information, content, materials, products, services, URLs,
            technology, filters, tools, documentation, and interactive features
            included with or available through Loóna Services (collectively, the
            “Loóna Content”) and all intellectual property rights to the same
            are owned by us, our licensors, or both. Additionally, all
            trademarks, service marks, trade names, and trade dress that may
            appear in Loóna Services are owned by us, our licensors, or
            identified third parties.
          </span>
        </p>
        <p>
          <span>
            We provide Loóna Services for educational, entertainment, and/or
            promotional purposes only. You may not rely on any information and
            opinions expressed through any of Loóna Services for any other
            purpose. In all instances, it is your responsibility to evaluate the
            accuracy, timeliness, completeness, or usefulness of any Loóna
            Content. Under no circumstances will we be liable for any loss or
            damage caused by your reliance on any Loóna Content.
          </span>
        </p>
        <p>
          <span>
            You are hereby granted a limited, non-exclusive, non-transferable,
            non-sublicensable, revocable license to use Loóna Service and the
            Loóna Content for your own personal use{' '}
            <strong>(“User License”)</strong>; however, such User License is
            subject to these Terms and and does not include any right to: (i)
            sell, resell or commercially use Loóna Services or the Loóna
            Content; (ii) copy, reproduce, distribute, publicly perform or
            publicly display the Loóna Content, except as expressly permitted by
            us or our licensors; (iii) modify the Loóna Content, remove any
            proprietary rights notices or markings, or otherwise make any any
            derivative uses of Loóna or the Loóna Content, except as in these
            Terms and the Additional Terms; (iv) use any data mining, mining,
            robots or similar data gathering or extraction methods; or (v) use
            Loóna or the Loóna Content other than as expressly provided Any use
            of Loóna or the Loóna Content other than as specifically authorized
            herein, without our prior written permission, is strictly prohibited
            and will terminate the User the User License granted under these
            Terms. You will not remove, alter or conceal any copyright,
            trademark, service mark or other proprietary rights notices
            incorporated in or accompanying the Loóna Content.
          </span>
        </p>
        <p>
          <span>
            Except for the limited use rights granted to you in these Terms of
            Use, you shall not acquire any right, title, or interest in our
            Services or any Loóna Content. Any rights not expressly granted in
            these Terms of Use are expressly reserved.
          </span>
        </p>
        <p>
          <span>
            You must not use any of the Loóna Content for commercial purposes
            unless you tell us first that you want to do this and we (or in the
            case of user content, the applicable User) agree to give you a
            separate license to do so to cover this use.
          </span>
        </p>
        <p>
          <span>
            Loóna Services may link or contain links to other websites
            maintained by third parties. We do not operate or control, in any
            respect, or necessarily endorse the content found on these
            third-party websites. You assume sole responsibility for your use of
            third-party links. We are not responsible for any content posted on
            third-party websites or liable to you for any loss or damage of any
            sort incurred as a result of your dealings with any third party or
            their website.
          </span>
        </p>

        <li>
          <b>In-app purchases and subscriptions</b>
        </li>
        <p>
          <span>
            <b>Free Use. </b>You may use some functionalities and features of
            Loóna Services free of charge. You may, but are not required to,
            provide us with your name and email address in connection with such
            use. Notably, Loóna Services will be limited for free use, and you
            will not have access to all of the functionalities and features
            available to paid users.
          </span>
        </p>
        <p>
          <span>
            <b>Paid Services.</b> We also offer subscription plans and in-app
            purchases that provide access to enhanced services and additional
            features for a fee <b>(“Purchased Content”)</b>. Certain content,
            products or services included in subscription may change from time
            to time, as we introduce new features, develop our existing offering
            and sometimes retire features that aren't working out as planned.
          </span>
        </p>
        <p>
          <span>
            By accessing Loóna Services you agree that your purchases are not
            contingent on the provision of any future functionality or features,
            or dependent on any oral or written public statements, and comments
            made by Loóna regarding such functionality or features.
          </span>
        </p>
        <p>
          <span>
            <b>Payment Method.</b> You may purchase a Purchased Content within
            the App or where allowed within the Website through a third party,
            such as Apple App Store, Google Play or other payment processor{' '}
            <b>(“Payment Processor”)</b>. If you purchase the Purchased Content
            from a third party, separate terms and conditions with such third
            party in addition to these terms may apply to your access to Loóna.
            Payment for Purchased Content will be charged to a credit/debit card
            or another payment method <b>(the “Payment Method”)</b> after you
            choose one of our Purchased Content and confirm your purchase.
          </span>
        </p>
        <ul>
          <li>
            You agree to promptly notify Loona of any changes to the Payment
            Method you provided while any subscriptions remain outstanding.
          </li>
          <li>
            You are responsible for all applicable fees and charges incurred,
            including applicable taxes.
          </li>
          <li>
            If payment is not received by us from the Payment Method you
            provided, you agree to pay all amounts due upon demand by us.
          </li>
          <li>
            Objections to a payment already made or cancellation requests should
            be directed to email hello@loona.app.
          </li>
        </ul>
        <p>
          <span>
            <b>Renewals.</b> Your payment to the third party through which you
            purchased Purchased Content, if any subscription period is
            applicable, will automatically renew and continue until terminated.
            You must cancel your subscription before it renews to avoid paying
            the subscription fees for the next billing period.
          </span>
        </p>
        <p>
          <span>
            <b>Refunds.</b> Generally, all purchases are final and
            non-refundable, unless required by law.
          </span>
        </p>
        <p>
          <span>
            <b>Apple App Store or Google Play Refunds.</b> We are unable to
            view, access, or modify any financial transactions from Apple (as
            defined below) or Google LLC in-app subscriptions for security and
            privacy reasons. Instead, we would ask that you reach out to the
            appropriate support team of Apple or Google LLC in relation to your
            subscription to request any refunds.
          </span>
        </p>
        <ul>
          <li>
            Your purchase will be subject to Apple App Store or Google Play
            applicable payment policy, which may or may not allow for refunds.
            Please contact the third party (Apple App Store or Google Play
            support) regarding any refunds or to manage your Purchased Content.
          </li>
          <li>
            If made via a Google in-app subscription or purchase learn more
            about refunds from Google Play{' '}
            <a href="https://support.google.com/googleplay/answer/2479637?hl%3Den">
              here.
            </a>
          </li>
          <li>
            You can request a refund for an Apple in-app subscription or
            purchase by following the guidance{' '}
            <a href="https://www.google.com/url?q=https://support.apple.com/en-us/HT204084&sa=D&source=docs&ust=1672240185135737&usg=AOvVaw3UfNsUPXn02hfmpwBtiZp6">
              here.
            </a>
          </li>
        </ul>
        <p>
          <span>
            NOTWITHSTANDING ANYTHING TO THE CONTRARY HEREIN AND SUBJECT TO
            MANDATORY LEGISLATION, YOU ACKNOWLEDGE THAT WE ARE NOT REQUIRED TO
            PROVIDE A REFUND FOR THE PURCHASED CONTENT FOR ANY REASON, AND THAT
            YOU WILL NOT RECEIVE MONEY OR OTHER COMPENSATION FOR THE UNUSED
            PURCHASED CONTENT, WHETHER YOUR LOSS WAS VOLUNTARY OR INVOLUNTARY.
          </span>
        </p>
        <p>
          <span>
            <b>Website Refunds.</b>{' '}
            <u>If you are a resident of the European Union and</u> where you
            purchase from the Website you agree to waive your cancellation and
            refund right once the Purchase Content is downloaded or the relevant
            purchase is made.{' '}
            <u>If you are not a resident of the European Union</u>
            and where you purchase from a Website, if your local laws do not
            regulate mandatory laws otherwise, you have no right to cancel
            purchases you made once the Purchase Content is downloaded or the
            relevant purchase is made. This means that you will not be able to
            cancel your order or obtain a refund once the download and delivery
            of the app is complete. This will also apply to subscriptions and
            in-app purchases.
          </span>
        </p>
        <p>
          <span>
            <b>Cancelation of Services.</b> You can cancel your Purchased
            Content by signing in to your account and following the in-app
            instructions for canceling your subscription. Please note that if
            you purchase a Purchased Content through the Apple App Store or
            Google Play, you may cancel your Purchased Content in accordance
            with the policies set forth by Apple and Google. Upon canceling of
            subscription you will not receive a refund for the fees you already
            paid for your Purchased Content and you will continue to receive
            Loóna Services ordered until the end of your current subscription
            period.
          </span>
        </p>
        <p>
          <span>
            <b>Changes in Pricing. </b> We reserve the right to change our
            subscription plans or adjust pricing that will be applicable to your
            future purchases for Loóna Services or any components thereof in any
            manner and at any time as we may determine in our sole and absolute
            discretion. Except as otherwise expressly provided for in these
            Terms, any price changes or changes to your subscription plan will
            take effect following notice to you.
          </span>
        </p>
        <p>
          <span>
            <b>Promotion and Discount Codes. </b> You may have access to a free
            trial period in accordance with certain promotional offers. Any
            promotion code or offer provided by us may not be used in
            conjunction with any other promotion code or offer, past or present.
            Introductory offers are only available to new users of Loóna
            Services, except where expressly stated otherwise. Previous users or
            trial users of the Loóna Services do not qualify as new users.
            Unless otherwise set forth in the terms of any promotion, all
            pricing promotions or discounts will apply to the initial period of
            the subscription, and any renewals will be charged at the
            non-discounted rate for the type of subscription purchased.
          </span>
        </p>

        <li>
          <b>Feedback</b>
        </li>
        <p>
          <span>
            We welcome any feedback from you about the content, the Loóna
            Services or otherwise, including how they can be improved. All
            feedback you provide is considered to be User Content and as such,
            you agree to grant us a license to use your feedback as set out
            below <b>(“Feedback”)</b>. Your Feedback is non-confidential and
            will become our sole property once submitted to us. We will own
            exclusive rights, including, without limitation, all intellectual
            property rights, in and to your Feedback and will be entitled to the
            unrestricted use and dissemination of your Feedback for any purpose,
            commercial or otherwise, without acknowledgment or compensation to
            you. You also have the right to amend and supplement your Feedback
            to us, which we will take into account to provide accurate
            information to other users about Loóna`s user experience. If we
            decide to make your Feedback public, we will not use any of your
            personal data, unless you explicitly consent to it.
          </span>
        </p>
        <li>
          <b>Indemnification</b>
        </li>
        <p>
          <span>
            You agree to indemnify and hold harmless Loóna and its officers,
            directors, employees, parents, partners, successors, agents,
            distribution partners, affiliates, subsidiaries, and their related
            companies from and against any and all claims, liabilities, losses,
            damages, obligations, costs and expenses (including reasonable
            attorneys’ fees and costs) arising out of, related to, or that may
            arise in connection with: (i) your use of Loóna Services; (ii) User
            Content or Feedback provided by you or through use of Loóna
            Services; (iii) any actual or alleged violation or breach by you of
            these Terms of Use; (iv) any actual or alleged breach of any
            representation, warranty, or covenant that you have made to us; (v)
            your acts or omissions or (vi) your conduct in connection with
            Loóna. You agree to cooperate fully with us in the defense of any
            claim that is the subject of your obligations hereunder. You also
            agree that the Company Parties will have control of the defense or
            settlement of any third party Claims. This indemnity is in addition
            to, and not in lieu of, any other indemnities set forth in a written
            agreement between you and us or the other Company Parties.
          </span>
        </p>

        <li>
          <b>Disclaimer of Warranties</b>
        </li>
        <p>
          <span>
            We do not control, endorse or take responsibility for any User
            Content (and its loss) or third-party content available on or linked
            to Loóna. You acknowledge sole responsibility for and assume all
            risk arising from your use of any third-party websites or resources.
          </span>
        </p>
        <p>
          <span>
            You expressly agree that use of Loóna Services is at your sole risk.
            Our services and Loóna Сontent (including software) are provided on
            an “as is” and “as available” basis without warranty of any kind,
            either express or implied. without limiting the foregoing and to the
            fullest extent permitted by law, Loóna and its officers, directors,
            employees, parents, partners, successors, agents, distribution
            partners, affiliates, subsidiaries, and their related companies
            disclaim any and all warranties including any: (i) warranties that
            our services will meet your requirements; (ii) warranties concerning
            the availability, accuracy, security, usefulness, timeliness, or
            informational content of our services or Loóna Сontent; (iii)
            warranties of title, non-infringement, merchantability, or fitness
            for a particular purpose; (iv) warranties for services or goods
            received through or advertised or accessed through our services; (v)
            warranties concerning the accuracy or reliability of the results
            that may be obtained from the use of our services; (vi) warranties
            that your use of our services will be secure or uninterrupted; and
            (vii) warranties that errors in our services or Loóna Сontent
            (including software) will be corrected.
          </span>
        </p>
        <li>
          <b>Limitation on Liability</b>
        </li>
        <p>
          <span>
            Under no circumstances shall Loóna or its officers, directors,
            employees, parents, partners, successors, agents, distribution
            partners, affiliates, subsidiaries, or their related companies be
            liable for indirect, incidental, special, consequential, or
            exemplary damages (even if we have been advised of the possibility
            of such damages), arising out of, relating to, or in any way
            connected with our services or these terms of use. your sole remedy
            for dissatisfaction with our services including, without limitation,
            Loóna Сontent is to stop using our services. such limitation shall
            also apply with respect to damages incurred by reason of goods
            received through or advertised in connection with our services or
            any links placed in our services, as well as by reason of any
            information or advice received through or advertised in connection
            with our services or any links placed in our services. such
            limitation shall also apply with respect to damages incurred by
            reason of any content posted by a third party or conduct of a third
            party using our services.
          </span>
        </p>

        <p>
          <span>
            Notwithstanding anything to the contrary contained herein, in no
            event shall the cumulative liability of Loóna and its officers,
            directors, employees, parents, partners, successors, agents,
            distribution partners, affiliates, subsidiaries, and their related
            companies exceed the lesser of the total payments received from you
            by Loóna during the preceding twelve (12) month period or $100.
            Furthermore, you agree that any cause of action arising out of,
            relating to, or in any way connected with any of Loóna Services or
            these terms of use must commence within one (1) year after the cause
            of action accrues; otherwise, such cause of action shall be
            permanently barred.
          </span>
        </p>

        <p>
          <span>
            In some jurisdictions limitations of liability are not permitted. In
            such jurisdictions, some of the foregoing limitations may not apply
            to you. These limitations shall apply to the fullest extent
            permitted by law.
          </span>
        </p>

        <li>
          <b>Release</b>
        </li>
        <p>
          <span>
            If you are a California resident you waive California Civil Code
            Section 1542, which says: “A general release does not extend to
            claims that the creditor or releasing party does not know or suspect
            to exist in his or her favour at the time of executing the release
            and that, if known by him or her, would have materially affected his
            or her settlement with the debtor or released party.”
          </span>
        </p>
        <li>
          <b>Right to terminate</b>
        </li>
        <p>
          <span>
            If you do not comply with our Terms or if we are investigating any
            suspected non-compliance or misconduct by you, we may take such
            action that we think is appropriate or necessary, including
            suspending or ending your access to the whole or any parts of the
            Loóna Services with immediate effect and permanently. If your
            non-compliance is curable, we will give you a reasonable opportunity
            to do so. You may contact us about your suspension or ending your
            access to Lóona Services at hello@loona.app.
          </span>
        </p>
        <p>
          <span>
            We retain the right to investigate any non-compliance with these
            Terms and any misconduct, we shall be entitled to take any action
            that we deem appropriate or necessary during or in response to such
            investigation.
          </span>
        </p>
        <p>
          <span>
            You may stop using the Lóona Services at any time.You may close your
            account and terminate the use of Lóona Services at any time by
            following the on-screen instructions or by contacting us at
            hello@loona.app.
          </span>
        </p>
        <p>
          <span>
            We may stop providing the Loóna Services (or parts of it) to you or
            add or create new limits to our Loóna Services (or parts of it) at
            any time.
          </span>
        </p>
        <p>
          <span>
            If we suspend or terminate your rights to use the Lóona Services:
          </span>
        </p>
        <ul>
          <li>
            you must stop all activities authorised by these Terms, including
            your use of the Lóona Services (and any Content);
          </li>
          <li>
            you must delete or remove the Lóona Services from all mobile devices
            in your possession and immediately destroy all copies of the Lóona
            Services which you have and confirm to us that you have done this;
            and
          </li>
          <li>
            we shall be entitled to remotely remove access to the Lóona Services
            from your devices and cease providing you with access to the Lóona
            Services.
          </li>
        </ul>
        <li>
          <b>COPYRIGHT NOTICE</b>
        </li>
        <p>
          <span>
            Loóna respects the intellectual property rights of others and
            requests that users of Loóna Services do the same. If you believe
            that your work is being used in connection with the Services in a
            way that constitutes copyright infringement, you may notify us by
            providing our copyright agent with the following information in
            writing: (a) the electronic or physical signature of the owner of
            the copyright or the person authorized to act on the owner’s behalf;
            (b) identification of the copyrighted work that you claim has been
            infringed; (c) identification of the material that is claimed to be
            infringing and information reasonably sufficient to permit Loóna to
            locate the material (for example, by providing a URL to the
            material); (d) your name, address, telephone number, and email
            address; (e) a statement by you that you have a good faith belief
            that the disputed use is not authorized by the copyright owner, its
            agent, or the law; and (f) a statement that the information in your
            notification is accurate and a statement, made under penalty of
            perjury, that you are the copyright owner or are authorized to act
            on the copyright owner’s behalf.
          </span>
        </p>
        <p>
          <span>
            You may send a notification of claimed infringement at email
            hello@loona.app.
          </span>
        </p>
        <p>
          <span>
            In appropriate circumstances, we will terminate the accounts of
            Users who are repeat copyright infringers.
          </span>
        </p>
        <li>
          <b>Dispute Resolution & Mandatory Arbitration</b>
        </li>
        <p>
          <span>
            We each agree to first contact each other with any disputes and
            provide a written description of the problem, all relevant
            documents/information, and the proposed resolution. You agree to
            contact us with disputes by contacting us at the address provided in
            these Terms of Use. We will contact you based on the contact
            information you have provided us.
          </span>
        </p>
        <p>
          <span>
            If after 30 days the parties are unable to resolve any dispute
            raised under the previous provision, the dispute may be submitted to
            arbitration consistent with this Section. The parties understand
            that they would have had a right or opportunity to litigate disputes
            through a court and to have a judge or jury decide their case, but
            they choose to have any disputes resolved through arbitration.
          </span>
        </p>
        <p>
          <span>
            <b>
              BINDING ARBITRATION AGREEMENT AND CLASS WAIVER DISCLOSURE
              (APPLICABLE TO <u>U.S. USERS ONLY</u>)
            </b>
          </span>
        </p>
        <p>
          <span>
            <b>Agreement to Arbitration; Class Waiver.</b>{' '}
            <u>If you are U.S. User</u> you and we agree, except as provided
            below regarding small claims court proceedings, any dispute, claim,
            or controversy arising out of or relating in any way to, the Loóna
            Service, and the Content, including, but not limited to, our{' '}
            <a href="/privacy">Privacy Policy</a> and/or our privacy practices
            generally, these Terms, and this Arbitration Agreement, shall be
            determined by binding arbitration. Arbitration is more informal than
            a lawsuit in court. Arbitration uses a neutral arbitrator instead of
            a judge or jury, allows for more limited discovery than in court,
            and is subject to very limited review by courts.{' '}
            <b>
              YOU AGREE THAT, BY AGREEING TO THESE TERMS, THE U.S. FEDERAL
              ARBITRATION ACT GOVERNS THE INTERPRETATION AND ENFORCEMENT OF
              THESE TERMS, AND THAT YOU AND WE ARE EACH WAIVING THE RIGHT TO A
              TRIAL BY JURY OR TO PARTICIPATE IN A CLASS ACTION.
            </b>{' '}
            This arbitration provision shall survive termination of these Terms.
          </span>
        </p>
        <p>
          <span>
            <b>Pre-Filing Mediation.</b> In the event of a dispute, prior to
            initiating arbitration, the party asserting the claim must first
            send to the other, by overnight courier, a written Notice of Claim
            (“Notice”). If you are the claimant, the Notice to Us must be
            addressed to: Loona Inc, 8 The Green, Ste B, Dover, DE, 19901, USA
            with a copy by email to hello@loona.app. If we are the claimant, the
            Notice must be sent to the address we have on file for you in your
            Account. The Notice must (a) describe the nature and basis of the
            claim or dispute; and (b) set forth the specific relief sought.
            Following receipt of the Notice, each party agrees to negotiate with
            the other in good faith about the claim. If the claim is not
            resolved to the satisfaction of the claimant within sixty (60) days
            after Notice is provided, the claimant may pursue the claim in
            arbitration or file a claim in small claims court, as appropriate{' '}
          </span>
        </p>

        <p>
          <span>
            <b>Additional Arbitration Provisions</b>
          </span>
        </p>
        <p>
          <span>
            Settlement Offers: During the arbitration, the amount of any
            settlement offer made by you or Us shall not be disclosed to the
            arbitrator.
          </span>
        </p>
        <p>
          <span>
            Initiating A Claim: The form required to initiate an arbitration can
            be printed or downloaded from www.adr.org. Alternatively, you may
            contact the arbitration administrator by calling 1-800-778-7879 or
            writing to the American Arbitration Association, 120 Broadway, Floor
            21, New York, NY 10271.
          </span>
        </p>
        <p>
          <span>
            Fees for Initiating Arbitration: If you are required to pay a filing
            fee to initiate arbitration, after we receive notice of the
            initiation of arbitration, We will promptly reimburse you for your
            payment of the filing fee at the address provided in the Notice,
            unless your claim is for greater than US$10,000.
          </span>
        </p>
        <p>
          <span>
            Applicable Rules; Administrator: The arbitration will be governed by
            the Commercial Arbitration Rules and the Supplementary Procedures
            for Consumer-Related Disputes (collectively, “AAA Rules”) of the
            American Arbitration Association (the “AAA”), as modified by these
            Terms, and will be administered by the AAA. The AAA Rules and Forms
            are available online at www.adr.org, by calling the AAA at
            1-800-778-7879 or writing to the American Arbitration Association,
            120 Broadway, Floor 21, New York, NY 10271. The arbitrator is bound
            by the terms of these Terms. All issues are for the arbitrator to
            decide, including issues relating to the scope and enforceability of
            this Arbitration Agreement.
          </span>
        </p>
        <p>
          <span>
            Location of Hearing: Unless you and We agree otherwise, any
            arbitration hearings will take place in New York, New York. If your
            claim is for US$10,000 or less, we agree you may choose whether the
            arbitration will be conducted solely on the basis of documents
            submitted to the arbitrator, through a telephonic hearing, or by an
            in-person hearing as established by the AAA Rules. If your claim
            exceeds US$10,000, the right to a hearing will be determined by the
            AAA Rules. Regardless of the manner in which the arbitration is
            conducted, the arbitrator shall issue a written decision sufficient
            to explain the essential findings and conclusions on which the award
            is based.
          </span>
        </p>
        <p>
          <span>
            Class Waiver: YOU AND WE AGREE THAT EACH MAY BRING CLAIMS AGAINST
            THE OTHER ONLY IN AN INDIVIDUAL CAPACITY AND NOT AS A PLAINTIFF OR
            CLASS MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE PROCEEDING.
            Further, unless both you and We agree otherwise, the arbitrator may
            not consolidate the claims of more than one party, and may not
            otherwise preside over any form of a representative or class
            proceeding. If this specific provision is found to be unenforceable
            as applied to any claim asserted by any individual, then the
            entirety of the arbitration provision set forth herein shall be null
            and void.
          </span>
        </p>
        <p>
          <span>
            Injunctive Relief Limitation: The arbitrator may award declaratory
            or injunctive relief only in favour of the individual party seeking
            relief and only to the extent necessary to provide the relief
            warranted by that party’s individual claim.
          </span>
        </p>
        <p>
          <span>
            Small Claims Procedure Alternative: Notwithstanding the foregoing
            binding arbitration procedure, either party may bring an individual
            action in small claims court (provided the claim otherwise qualifies
            for such a program) as an alternative to proceeding with
            arbitration.
          </span>
        </p>
        <p>
          <span>
            <b>Opt-Out Provision.</b> YOU HAVE THE RIGHT TO OPT-OUT OF THIS
            ARBITRATION PROVISION WITHIN THIRTY (30) DAYS FROM THE DATE THAT YOU
            FIRST USE, OR ATTEMPT TO USE, THE LOÓNA SERVICES BY WRITING TO
            hello@loona.app OR TO THE ARBITRATION NOTICE ADDRESS. FOR YOUR
            OPT-OUT TO BE EFFECTIVE, YOU MUST SUBMIT A SIGNED WRITTEN NOTICE
            OPTING OUT AND CONTAINING ENOUGH DETAILS ABOUT YOU FOR US TO BE ABLE
            TO IDENTIFY YOU WITHIN THIRTY (30) DAYS. IF MORE THAN THIRTY (30)
            DAYS HAVE PASSED, YOU ARE NOT ELIGIBLE TO OPT OUT OF THIS PROVISION
            AND YOU MUST PURSUE YOUR CLAIM THROUGH BINDING ARBITRATION AS SET
            FORTH IN THESE TERMS.
          </span>
        </p>
        <p>
          <span>
            YOU ACKNOWLEDGE AND AGREE THAT THE BINDING ARBITRATION AGREEMENT AND
            THE CLASS ACTION WAIVER, AS WELL AS WARRANTY DISCLAIMERS AND
            LIABILITY AND REMEDY LIMITATIONS IN THESE TERMS ARE MATERIAL TERMS
            OF THESE TERMS AND THAT THEY HAVE BEEN TAKEN INTO ACCOUNT IN THE
            DECISION BY US TO PROVIDE THE LOÓNA SERVICE.
          </span>
        </p>
        <p>
          <span>
            <b>No Trial by Jury.</b> TO THE EXTENT ALLOWED BY LAW, WE EACH WAIVE
            ANY RIGHT TO TRIAL BY JURY IN ANY LAWSUIT, ARBITRATION OR OTHER
            PROCEEDING.
          </span>
        </p>
        <li>
          <b>Miscellaneous</b>
        </li>
        <p>
          <span>
            <u>Assignment.</u> We can assign, transfer, or subcontract any or
            all of our rights and obligations under these Terms to another
            organization. We will always tell you in writing if this happens and
            we will ensure that the transfer will not affect your rights as set
            out in these Terms. You may only transfer your rights or your
            obligations under these Terms to another person if we agree in
            writing in advance.
          </span>
        </p>
        <p>
          <span>
            <u>Third Party Rights.</u> These Terms are between you and us and
            are not intended to give third parties any rights to enforce all or
            any part of these Terms.
          </span>
        </p>
        <p>
          <span>
            <u>Severability</u> Each of the paragraphs of these Terms operates
            separately. If any court or relevant authority decides that any of
            them are unlawful, the remaining paragraphs will remain in full
            force and effect.
          </span>
        </p>
        <p>
          <span>
            <u>International Use.</u> You represent and warrant that you are in
            compliance with all laws, restrictions and regulations administered
            by the Office of Foreign Assets Control (“OFAC”) or any other
            foreign governmental entity imposing economic sanctions and trade
            embargoes (“Economic Sanctions Laws”) against designated countries
            (“Embargoed Countries”), entities and persons (collectively,
            “Embargoed Targets”). You represent and warrant that you are not an
            Embargoed Target or otherwise subject to any Economic Sanctions Law.
            You agree to comply with all Economic Sanctions Laws. Without
            limiting the generality of the foregoing, you agree not to (a)
            directly or indirectly export, re-export, transship or otherwise
            deliver any products, services, technology, or information of any
            portion thereof to an Embargoed Target or (b) broker or otherwise
            facilitate any transaction in violation of any Economic Sanctions
            Laws.
          </span>
        </p>
        <p>
          <span>
            <u>Applicable Law and Jurisdiction. </u>
          </span>
        </p>
        <p>
          <span>
            For members residing in the United Kingdom (UK), European Union (EU)
            or European Economic Area (EEA) or elsewhere where our arbitration
            agreement is prohibited by law, the laws of England, excluding
            conflict of laws rules, will apply to any disputes arising out of or
            relating to this Agreement or the Loóna Services. For the avoidance
            of doubt, the choice of English governing law shall not supersede
            any mandatory consumer protection legislation in such jurisdictions.
          </span>
        </p>

        <p>
          <span>
            Except for members residing in the UK, EU or EEA who may bring
            claims in their country of residence in accordance with applicable
            law and except for claims that may be properly brought in a small
            claims court of competent jurisdiction, all claims arising out of or
            relating to this Agreement, to the Loóna Services, or to your
            relationship with Loóna that for whatever reason are not submitted
            to arbitration will be litigated exclusively in the courts of
            England.
          </span>
        </p>

        <p>
          <span>
            <u>If you are U.S. User</u>, this Agreement, and all claims and
            causes of action in connection with, arising under or relating to
            the subject matter of these terms and conditions, in the broadest
            possible way, including tort claims (the “Claims”), shall be
            governed by, and construed in accordance with the laws of the State
            of Delaware without regard to its choice of law principles. To the
            extent applicable, the parties expressly disclaim the application of
            the United Nations Convention on Contracts for the International
            Sale of Goods. The choice of law designated herein shall apply to
            all factual and legal issues relating to or arising under the
            contract and shall survive termination of this Agreement.
          </span>
        </p>

        <p>
          <span>
            <u>If you are a U.S. User</u>, further you and the Company agree to
            the jurisdiction of Delaware to resolve any Claims that relate to or
            arise in connection with these Terms and that are not subject to
            mandatory arbitration under Section 14.
          </span>
        </p>

        <p>
          <span>
            <u>No Waiver.</u> If we do not insist immediately that you do
            anything you are required to do under these Terms, or if we delay in
            taking steps against you in respect of your non-compliance with any
            of these Terms, that will not mean that you do not have to do those
            things and it will not prevent us taking steps against you at a
            later date.
          </span>
        </p>

        <p>
          <span>
            <u>Contact Us.</u> If you have any questions or concerns regarding
            these Terms, you may contact us by email at hello@loóna.app.
          </span>
        </p>
      </ol>
    </PageWrapper>
  );
};
